import Support from '../components/supportpage/Support';

const SupportPage = () => {
    return (
        <>
            <Support />
        </>
    );
};

export default SupportPage;
